import { createAppAsyncThunk } from '../../store/extensions';
import { CreateDiagnosisDto, UpdateDiagnosisDto } from './dtos';
import {
  deleteDiagnosisCall,
  fetchDiagnosesCall,
  insertDiagnosesCall,
  searchDiagnosesCall,
  updateDiagnosisCall,
} from './service';

export const fetchDiagnoses = createAppAsyncThunk(
  'healthjourney/diagnosis/getAll',
  (journeyId: string) => {
    return fetchDiagnosesCall(journeyId);
  }
);

export const searchDiagnoses = createAppAsyncThunk(
  'healthjourney/diagnosis/searchDiagnoses',
  (searchString: string) => {
    return searchDiagnosesCall(searchString);
  }
);

export const insertDiagnoses = createAppAsyncThunk(
  'healthjourney/diagnosis/insert',
  (diagnoses: CreateDiagnosisDto[]) => {
    return insertDiagnosesCall(diagnoses);
  }
);

export const updateDiagnosis = createAppAsyncThunk(
  'healthjourney/diagnosis/update',
  (diagnosis: UpdateDiagnosisDto) => {
    return updateDiagnosisCall(diagnosis);
  }
);

export const deleteDiagnosis = createAppAsyncThunk(
  'healthjourney/diagnosis/delete',
  (diagnosisId: string) => {
    return deleteDiagnosisCall(diagnosisId);
  }
);
